var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1637_18861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99262 1.33252H3.99653C3.64314 1.33252 3.30422 1.4729 3.05433 1.72279C2.80445 1.97268 2.66406 2.31159 2.66406 2.66498V13.3247C2.66406 13.6781 2.80445 14.017 3.05433 14.2669C3.30422 14.5168 3.64314 14.6572 3.99653 14.6572H11.9913C12.3447 14.6572 12.6836 14.5168 12.9335 14.2669C13.1834 14.017 13.3238 13.6781 13.3238 13.3247V4.66368L9.99262 1.33252Z",
    stroke: "#3B82F6",
    strokeWidth: 1.33247,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.32812 1.33252V3.99745C9.32812 4.35084 9.46851 4.68976 9.7184 4.93965C9.96828 5.18953 10.3072 5.32992 10.6606 5.32992H13.3255",
    stroke: "#3B82F6",
    strokeWidth: 1.33247,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66254 5.99609H5.33008",
    stroke: "#3B82F6",
    strokeWidth: 1.33247,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6599 8.66101H5.33008",
    stroke: "#3B82F6",
    strokeWidth: 1.33247,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6599 11.3259H5.33008",
    stroke: "#3B82F6",
    strokeWidth: 1.33247,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1637_18861"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9896,
    height: 15.9896,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.1d45b1963d2e6fac858a4ead25b874c6.svg";
export { ForwardRef as ReactComponent };